import { computed, ref, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { getQuery, getQueryFuzzy, postEdit, saveAdd } from '@/api/payManage/appManage';
import { OK, reportEvent } from '@/common';
import { message } from 'ant-design-vue';
import { getEntityBuFen } from '@/api/payManage/accountManage';
export default /*#__PURE__*/_defineComponent({
  __name: 'AppAddOrEditModal',
  props: {
    modalVisible: {
      type: Boolean
    },
    dataItem: null
  },
  emits: ['update:modalVisible', 'refresh'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const isEdit = computed(() => {
      var _props$dataItem;
      return !!((_props$dataItem = props.dataItem) !== null && _props$dataItem !== void 0 && _props$dataItem.id);
    });
    const visible = ref(false),
      loading = ref(false),
      accountForm = ref(),
      formValue = ref({
        dbtId: undefined,
        appName: undefined,
        mchId: undefined,
        mchName: undefined,
        studio: undefined,
        accountId: undefined,
        accountName: undefined,
        publishPlatform: undefined,
        publishPlatformName: undefined,
        productType: undefined
      }),
      dbtIdError = ref(''),
      rules = ref({
        dbtId: [{
          required: true,
          message: '请输入dbtId',
          trigger: 'blur'
        }],
        mchId: [{
          required: true,
          message: '请选择主体/账号',
          trigger: 'change'
        }],
        appName: [{
          required: true,
          message: '请输入dbtId,点击搜索后自动生成',
          trigger: 'change'
        }],
        studio: [{
          required: true,
          message: '请输入dbtId,点击搜索后自动生成',
          trigger: 'change'
        }],
        publishPlatformName: [{
          required: true,
          message: '请输入dbtId,点击搜索后自动生成',
          trigger: 'change'
        }]
      }),
      accountList = ref([]);
    const onSearch = async () => {
        if (!formValue.value.dbtId) {
          return dbtIdError.value = 'dbtId不能为空';
        }
        const params = {
          dbtId: formValue.value.dbtId
        };
        try {
          const {
            code,
            data,
            msg
          } = await getQueryFuzzy(params);
          if (code !== OK) {
            dbtIdError.value = msg;
          }
          if (data !== null && data !== void 0 && data.appExisted) {
            dbtIdError.value = '该产品已添加，不可重复添加';
          } else {
            var _accountForm$value;
            updateData(data);
            (_accountForm$value = accountForm.value) === null || _accountForm$value === void 0 || _accountForm$value.clearValidate();
          }
        } catch (e) {}
      },
      changeform = async params => {
        try {
          var _props$dataItem2;
          loading.value = true;
          const {
            code,
            msg
          } = (_props$dataItem2 = props.dataItem) !== null && _props$dataItem2 !== void 0 && _props$dataItem2.id ? await postEdit(params) : await saveAdd(params);
          if (code === OK) {
            var _props$dataItem3;
            message.success(msg);
            closeModal();
            emit('refresh');
            reportEvent({
              eventName: 'element_use',
              properties: {
                ui_name: '产品管理',
                element_name: (_props$dataItem3 = props.dataItem) !== null && _props$dataItem3 !== void 0 && _props$dataItem3.id ? '编辑' : '新建'
              }
            });
          }
        } catch (e) {} finally {
          loading.value = false;
        }
      },
      query = async obj => {
        const params = {
          id: obj.id
        };
        try {
          const {
            code,
            data
          } = await getQuery(params);
          if (code === OK) {
            updateData(data);
          }
        } catch (e) {}
      };
    const closeModal = () => {
      var _accountForm$value2;
      (_accountForm$value2 = accountForm.value) === null || _accountForm$value2 === void 0 || _accountForm$value2.clearValidate();
      dbtIdError.value = '';
      emit('update:modalVisible', false);
    };
    const handleOk = () => {
      var _accountForm$value3;
      (_accountForm$value3 = accountForm.value) === null || _accountForm$value3 === void 0 || _accountForm$value3.validate().then(() => {
        var _props$dataItem4;
        let params = JSON.parse(JSON.stringify(formValue.value));
        if ((_props$dataItem4 = props.dataItem) !== null && _props$dataItem4 !== void 0 && _props$dataItem4.id) {
          params = {
            ...formValue.value,
            id: props.dataItem.id
          };
        }
        changeform(params);
      }).catch(error => {});
    };
    const getAccountList = async () => {
      const {
        code,
        data
      } = await getEntityBuFen().catch(e => {});
      if (code === OK) {
        accountList.value = data.map(item => {
          return {
            label: item.typeName,
            value: item.id
          };
        });
      }
    };
    // 更新相关数据
    const updateData = (data = {}) => {
      var _Object$keys;
      if (data && (_Object$keys = Object.keys(data)) !== null && _Object$keys !== void 0 && _Object$keys.length) {
        formValue.value = {
          dbtId: data.dbtId,
          appName: data.appName,
          mchId: data.mchId || undefined,
          mchName: data.mchName,
          accountId: data.accountId,
          accountName: data.accountName,
          publishPlatform: data.publishPlatform,
          publishPlatformName: data.publishPlatformName,
          studio: data.studio,
          productType: data.productType
        };
      } else {
        formValue.value = {
          dbtId: undefined,
          appName: undefined,
          mchId: undefined,
          mchName: undefined,
          accountId: undefined,
          accountName: undefined,
          publishPlatform: undefined,
          publishPlatformName: undefined,
          studio: undefined,
          productType: undefined
        };
      }
    };
    watch(() => props.modalVisible, n => {
      visible.value = n;
      if (visible.value) getAccountList();
    }, {
      immediate: true
    });
    watch(() => props.dataItem, newValue => {
      if (newValue.id) {
        //编辑
        query(newValue);
      } else {
        // 新增
        updateData();
      }
    }, {
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_a_input_search = _resolveComponent("a-input-search");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_col = _resolveComponent("a-col");
      const _component_a_row = _resolveComponent("a-row");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: visible.value,
        "onUpdate:open": _cache[5] || (_cache[5] = $event => visible.value = $event),
        title: _unref(isEdit) ? '编辑产品信息' : '新建产品信息',
        width: "650px",
        centered: "",
        "ok-text": "提交",
        "confirm-loading": loading.value,
        onOk: handleOk,
        onCancel: closeModal,
        maskClosable: false
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          name: "accountForm",
          model: formValue.value,
          ref_key: "accountForm",
          ref: accountForm,
          rules: rules.value,
          labelCol: {
            style: {
              width: '86px'
            }
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_a_row, {
            gutter: 16
          }, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "dbtID：",
                name: "dbtId",
                help: dbtIdError.value,
                "validate-status": dbtIdError.value ? 'error' : ''
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input_search, {
                  value: formValue.value.dbtId,
                  "onUpdate:value": _cache[0] || (_cache[0] = $event => formValue.value.dbtId = $event),
                  valueModifiers: {
                    trim: true
                  },
                  placeholder: "请输入dbtId搜索",
                  onSearch: onSearch,
                  onChange: _cache[1] || (_cache[1] = $event => dbtIdError.value = ''),
                  disabled: _unref(isEdit)
                }, null, 8, ["value", "disabled"])]),
                _: 1
              }, 8, ["help", "validate-status"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_row, {
            gutter: 16
          }, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "产品名：",
                name: "appName"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  value: formValue.value.appName,
                  "onUpdate:value": _cache[2] || (_cache[2] = $event => formValue.value.appName = $event),
                  placeholder: "产品名"
                }, null, 8, ["value"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "工作室：",
                name: "studio"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  value: formValue.value.studio,
                  "onUpdate:value": _cache[3] || (_cache[3] = $event => formValue.value.studio = $event),
                  placeholder: "工作室",
                  disabled: ""
                }, null, 8, ["value"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_row, {
            gutter: 16
          }, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 12
            }, {
              default: _withCtx(() => [formValue.value.accountId ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 0,
                label: "主体/账号：",
                name: "accountId",
                required: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  disabled: "",
                  value: formValue.value.accountName
                }, null, 8, ["value"])]),
                _: 1
              })) : (_openBlock(), _createBlock(_component_a_form_item, {
                key: 1,
                label: "主体/账号：",
                name: "mchId"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_select, {
                  value: formValue.value.mchId,
                  "onUpdate:value": _cache[4] || (_cache[4] = $event => formValue.value.mchId = $event),
                  placeholder: "主体/账号",
                  options: accountList.value,
                  disabled: _unref(isEdit)
                }, null, 8, ["value", "options", "disabled"])]),
                _: 1
              }))]),
              _: 1
            }), _createVNode(_component_a_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "市场",
                name: "publishPlatformName",
                required: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  disabled: "",
                  value: formValue.value.publishPlatformName,
                  placeholder: "市场"
                }, null, 8, ["value"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["open", "title", "confirm-loading"]);
    };
  }
});